import _ from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import VideoPlayer from "react-video-js-player";
import { Formik } from "formik";
import * as Yup from "yup";
import { Spinner } from "react-bootstrap";
import { scroller } from "react-scroll";
import {
  fetchRolePlayData,
  fetchRolePlayDataClear,
  reviewRolePlayList,
  submitReviewForm,
  submitReviewFormClear,
} from "../../redux/roleplay/actions";
import { getWordSpeedType, SessionKeys } from "../../utils/AppUtils";
import { Link } from "react-router-dom";
import { Rating } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { Collapse } from "reactstrap";
import RolePlayAssetLibrarySection from "./RolePlayAssetLibrarySection";

const ReviewOverView = (props) => {
  const {
    roleData,
    listing,
    setClickedRolePlayData,
    isLoading,
    setIsLoading,
    setShowModalMsg,
    setConfirmModal,
    showForReview,
    fetchReviewFilterList,
    reviewType,
  } = props;

  const dispatch = useDispatch();
  let formikInstance;
  const authBroker = useSelector((state) => state.auth.authBroker);
  const feedbackForm = useSelector((state) => state.rolePlay.feedbackForm);
  const singleRoleData = useSelector((state) => state.rolePlay.rolePlayData)

  const [openCollapse, setOpenCollapse] = useState(false);
  const [roleListing] = useState(true);
  const [roleInfo, setRoleInfo] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [msg, setMsg] = useState("");
  const [rolePlayGuide, setRolePlayGuide] = useState('')
  const [masterRoleData, setMasterRoleData] = useState('')
  const [rubricData, setRubricData] = useState([])
  const [overallScore, setOverallScore] = useState(0)
  const [starRatings] = useState([
    { value: 0, label: "0 Stars" },
    { value: 1, label: "1 Stars" },
    { value: 2, label: "2 Stars" },
    { value: 3, label: "3 Stars" },
    { value: 4, label: "4 Stars" },
    { value: 5, label: "5 Stars" },
  ]);

  const [initialValues, setInitialValues] = useState({
    // awarness: 0,
    // research: 0,
    // impact: 0,
    // empathy: 0,
    rating: {},
    comments: "",
    solution_id: "",
    solution_url: "",
  });

  const formSchema = Yup.object().shape({
    // awarness: Yup.number().required("Please select value"),
    // research: Yup.number().required("Please select value"),
    // impact: Yup.number().required("Please select value"),
    // empathy: Yup.number().required("Please select value"),
    comments: Yup.string().required("Please input comments"),
    solution_id: Yup.string().optional(),
    solution_url: Yup.string().optional(),
  });

  useEffect(() => {
    scroller.scrollTo("review-overview-id", {
      duration: 50,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  }, [dispatch])

  useEffect(() => {
    if (!_.isEmpty(roleData)) {
      console.log('setRole Data', roleData)
      setMsg("");
      setRoleInfo({});
      dispatch(
        fetchRolePlayData({
          module: 'getSingleRolePlayData',
          postData: {
            module: 'AllRolesApi',
            id: roleData.id
          }
        })
      )
      // setTimeout(() => {
      //   setIsLoading(false);
        // setRoleInfo(roleData);
        
      // }, 500);
    }
  }, [roleData]);

  useEffect(() => {
    console.log(singleRoleData)
    if (!_.isEmpty(singleRoleData)) {
      setIsLoading(false)
      if (singleRoleData.status === 'success') {
        const data = singleRoleData.payload.payload;
        if (!_.isEmpty(data)) {
          setMasterRoleData(data);
          setRubricData(data.rubric_data);
          setRolePlayGuide(data.roleplay_guide);
        }
        const keywordData = roleData.roleplay_keyword_analysis;
        let score = 0;
        let total_wt = 0;
        for (let keyword of keywordData) {
            score = score + _.toNumber(keyword.wt)
            total_wt = total_wt + _.toNumber(keyword.wt_og);
        }
        if (score === 0) {
            setOverallScore(0)
        } else {
            setOverallScore((score/keywordData.length).toFixed(2))
        }
        setRoleInfo(roleData)
      }
      dispatch(fetchRolePlayDataClear())
    }
  }, [singleRoleData])

  useEffect(() => {
    if (!_.isEmpty(rubricData)) {
      let rating = {}
      for(let data of rubricData) {
        let rubric = data
        rating[rubric] = 0;
      }
      setInitialValues({
        rating: rating,
        comments: "",
        solution_id: "",
        solution_url: ""
      })
    }
  }, [rubricData])

  useEffect(() => {
    // console.log('FEEDBACK FORM', feedbackForm)
    if (!_.isEmpty(feedbackForm)) {
      if (feedbackForm.status === "success") {
        // setMsg('Feedback submitted.')
        window.scrollTo(0, 0);
        setShowModalMsg("Feedback submitted.");
        setConfirmModal(true);
        fetchReviewFilterList();
        setIsLoading(true);
        setClickedRolePlayData({});
        setRoleInfo({});
      } else {
        setMsg("Error submitting feedback.");
      }
      setIsSubmit(false);
      dispatch(submitReviewFormClear());
    }
  }, [feedbackForm]);

  const handleSubmit = (values) => {
     console.log(values, roleInfo, roleData)
    // return;
    setIsSubmit(true);
    setMsg("");
    let postData = {
      roleplay_id: _.toNumber(roleInfo.role_play_id),
      roleplay_title: roleInfo.title,
      coach_uid: authBroker?.payload?.user?.user_id,
      review_status: "yes",
      rating: values.rating,
      additional_comment: values.comments,
      solution_id: values.solution_id,
      solution_url: values.solution_url,
    };
    console.log(postData)
    dispatch(
      submitReviewForm({
        module: "submitFeedbackRolePlay",
        postData,
      })
    );
  };

  return (
    <>
      <section className="reviewoverview door-knowking" id="review-overview-id">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mb-3">
              <button
                className="btn btn-primary setup-button"
                onClick={() => {
                  // clickStreamUser('back-btn-session-video', {
                  // userId: authBroker?.payload?.user.user_id
                  // })
                  showForReview("");
                }}
              >
                Back
              </button>
            </div>
          </div>
          {!_.isEmpty(roleInfo) && roleListing ? (
            <div className="row">
              <div className="col-lg-12 col-sm-12">
                <div className="videobox row">
                  <div className="col-md-12">
                    <h5
                      className="videotitle"
                      dangerouslySetInnerHTML={{
                        __html: roleInfo.roleplay_category,
                      }}
                    ></h5>
                  </div>
                  <div className="col-lg-7 col-sm-12">
                    <div className="reviewvideoplayer">
                      {/* <img src="/images/rec_new.jpeg" /> */}
                      <VideoPlayer
                        controls={true}
                        src={roleInfo?.roleplay_url}
                        width={"100%"}
                      />
                    </div>
                    <div className="col-lg-12 col-sm-12 mt-4 leftseccomgnh">
                        <div className="box-rating-rolplay d-flex">
                          <div className="videotimebox d-flex gap-2 iconspitch">
                              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 16 16"><path id="Speed" d="M11690-1677a8.009,8.009,0,0,1-8-8,8.009,8.009,0,0,1,8-8,8.009,8.009,0,0,1,8,8A8.009,8.009,0,0,1,11690-1677Zm-.023-6.749h0l.967.909v2.727h.919v-3.408l-.966-.91.275-1.365a3.409,3.409,0,0,0,2.534,1.136v-.907a2.267,2.267,0,0,1-1.979-1.092l-.461-.728a.958.958,0,0,0-.783-.455.9.9,0,0,0-.186.024.908.908,0,0,1-.185.023l-2.4,1v2.134h.922v-1.544l.828-.32-.737,3.684-2.255-.455-.185.91,3.224.637.461-2Zm1.2-6.139a.917.917,0,0,0-.922.91.917.917,0,0,0,.922.91.917.917,0,0,0,.922-.91A.917.917,0,0,0,11691.174-1689.888Z" transform="translate(-11682 1693)" fill="#FF007F"></path></svg>
                              <div className="textbox">
                                  Pitch Rate
                                  <strong className="coloredtrack">{getWordSpeedType(roleInfo.roleplay_wpm)}</strong>
                              </div>
                          </div>
                          <div className="videotimebox textnpm-box">
                              <div className="wpmtitle">{roleInfo.roleplay_wpm} WPM</div>
                              {/* <div className="subwpmtext">Target: 120-150</div> */}
                          </div>
                        </div>
                        <div className="sentimant-box">
                          <div className="overview-row">
                            {/* <p className="setimatetitle">Sentiment Analysis</p> */}
                            <div className="d-flex ratings-role">
                              <div className="rolerate">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="27.431"
                                  height="27.431"
                                  viewBox="0 0 27.431 27.431"
                                >
                                  <g id="emoji" transform="translate(0.5 0.5)">
                                    <g
                                      id="Path_12027"
                                      data-name="Path 12027"
                                      transform="translate(-127.455 -264.14)"
                                      fill="#0faa36"
                                    >
                                      <path
                                        d="M 140.6706237792969 285.43359375 C 137.1804656982422 285.43359375 134.3410034179688 282.5941467285156 134.3410034179688 279.10400390625 L 134.3410034179688 278.85400390625 L 134.5910034179688 278.85400390625 L 146.7502136230469 278.85400390625 L 147.0002136230469 278.85400390625 L 147.0002136230469 279.10400390625 C 147.0002136230469 282.5941467285156 144.1607818603516 285.43359375 140.6706237792969 285.43359375 Z"
                                        stroke="none"
                                      />
                                      <path
                                        d="M 140.6706237792969 285.18359375 C 144.0282592773438 285.18359375 146.7502136230469 282.461669921875 146.7502136230469 279.10400390625 L 134.5910034179688 279.10400390625 C 134.5910034179688 282.461669921875 137.3129272460938 285.18359375 140.6706237792969 285.18359375 M 140.6706237792969 285.68359375 C 137.0426177978516 285.68359375 134.0910034179688 282.7319946289062 134.0910034179688 279.10400390625 L 134.0910034179688 278.60400390625 L 147.2502136230469 278.60400390625 L 147.2502136230469 279.10400390625 C 147.2502136230469 282.7319946289062 144.2986297607422 285.68359375 140.6706237792969 285.68359375 Z"
                                        stroke="none"
                                        fill="#0faa36"
                                      />
                                    </g>
                                    <g
                                      id="Ellipse_57"
                                      data-name="Ellipse 57"
                                      transform="translate(6.176 7.124)"
                                      fill="#0faa36"
                                      stroke="#0faa36"
                                      strokeWidth="0.5"
                                    >
                                      <ellipse
                                        cx="2.348"
                                        cy="2.348"
                                        rx="2.348"
                                        ry="2.348"
                                        stroke="none"
                                      />
                                      <ellipse
                                        cx="2.348"
                                        cy="2.348"
                                        rx="2.598"
                                        ry="2.598"
                                        fill="none"
                                      />
                                    </g>
                                    <g
                                      id="Ellipse_58"
                                      data-name="Ellipse 58"
                                      transform="translate(15.558 7.124)"
                                      fill="#0faa36"
                                      stroke="#0faa36"
                                      strokeWidth="0.5"
                                    >
                                      <ellipse
                                        cx="2.348"
                                        cy="2.348"
                                        rx="2.348"
                                        ry="2.348"
                                        stroke="none"
                                      />
                                      <ellipse
                                        cx="2.348"
                                        cy="2.348"
                                        rx="2.598"
                                        ry="2.598"
                                        fill="none"
                                      />
                                    </g>
                                    <g
                                      id="Path_12028"
                                      data-name="Path 12028"
                                      transform="translate(0 0)"
                                      fill="#0faa36"
                                    >
                                      <path
                                        d="M 22.70437622070312 26.68081855773926 L 3.726536512374878 26.68081855773926 C 1.533866405487061 26.68081855773926 -0.2500035464763641 24.8969783782959 -0.2500035464763641 22.7043399810791 L -0.2500035464763641 3.726529359817505 C -0.2500035464763641 1.533859252929688 1.533866405487061 -0.2500007152557373 3.726536512374878 -0.2500007152557373 L 22.70431709289551 -0.2500007152557373 C 24.89698600769043 -0.2500007152557373 26.68085670471191 1.533859252929688 26.68085670471191 3.726529359817505 L 26.68085670471191 22.70428848266602 C 26.68085670471191 24.89695930480957 24.89701652526855 26.68081855773926 22.70437622070312 26.68081855773926 Z M 3.726536512374878 1.901929259300232 C 2.720446348190308 1.901929259300232 1.901926398277283 2.720439195632935 1.901926398277283 3.726529359817505 L 1.901926398277283 22.7043399810791 C 1.901926398277283 23.71043014526367 2.720446348190308 24.52894973754883 3.726536512374878 24.52894973754883 L 22.70437622070312 24.52894973754883 C 23.7104663848877 24.52894973754883 24.52897644042969 23.71043014526367 24.52897644042969 22.7043399810791 L 24.52897644042969 3.726529359817505 C 24.52897644042969 2.720439195632935 23.7104663848877 1.901929259300232 22.70437622070312 1.901929259300232 L 3.726536512374878 1.901929259300232 Z"
                                        stroke="none"
                                      />
                                      <path
                                        d="M 22.70437622070312 26.43081855773926 C 24.75874710083008 26.43081855773926 26.43085670471191 24.75871849060059 26.43085670471191 22.70428848266602 L 26.43085670471191 3.726529359817505 C 26.43085670471191 1.672099232673645 24.75874710083008 -7.211303909571143e-07 22.70431709289551 -7.211303909571143e-07 L 3.726536512374878 -7.211303909571143e-07 C 1.671666502952576 -7.211303909571143e-07 -3.554992645149468e-06 1.672099232673645 -3.554992645149468e-06 3.726529359817505 L -3.554992645149468e-06 22.7043399810791 C -3.554992645149468e-06 24.75871849060059 1.671666502952576 26.43081855773926 3.726536512374878 26.43081855773926 L 22.70437622070312 26.43081855773926 M 3.726536512374878 1.651929259300232 L 22.70437622070312 1.651929259300232 C 23.8481273651123 1.651929259300232 24.77897644042969 2.582779169082642 24.77897644042969 3.726529359817505 L 24.77897644042969 22.7043399810791 C 24.77897644042969 23.84809875488281 23.8481273651123 24.77894973754883 22.70437622070312 24.77894973754883 L 3.726536512374878 24.77894973754883 C 2.582776546478271 24.77894973754883 1.651926398277283 23.84809875488281 1.651926398277283 22.7043399810791 L 1.651926398277283 3.726529359817505 C 1.651926398277283 2.582779169082642 2.582776546478271 1.651929259300232 3.726536512374878 1.651929259300232 M 22.70437622070312 26.93081855773926 L 3.726536512374878 26.93081855773926 C 1.396016478538513 26.93081855773926 -0.5000035762786865 25.03483009338379 -0.5000035762786865 22.7043399810791 L -0.5000035762786865 3.726529359817505 C -0.5000035762786865 1.39600932598114 1.396016478538513 -0.5000007152557373 3.726536512374878 -0.5000007152557373 L 22.70431709289551 -0.5000007152557373 C 25.03483581542969 -0.5000007152557373 26.93085670471191 1.39600932598114 26.93085670471191 3.726529359817505 L 26.93085670471191 22.70428848266602 C 26.93085670471191 25.03480911254883 25.03486633300781 26.93081855773926 22.70437622070312 26.93081855773926 Z M 3.726536512374878 2.151929378509521 C 2.858296394348145 2.151929378509521 2.151926517486572 2.858289241790771 2.151926517486572 3.726529359817505 L 2.151926517486572 22.7043399810791 C 2.151926517486572 23.57257843017578 2.858296394348145 24.27894973754883 3.726536512374878 24.27894973754883 L 22.70437622070312 24.27894973754883 C 23.57261657714844 24.27894973754883 24.27897644042969 23.57257843017578 24.27897644042969 22.7043399810791 L 24.27897644042969 3.726529359817505 C 24.27897644042969 2.858289241790771 23.57261657714844 2.151929378509521 22.70437622070312 2.151929378509521 L 3.726536512374878 2.151929378509521 Z"
                                        stroke="none"
                                        fill="#0faa36"
                                      />
                                    </g>
                                  </g>
                                </svg>
                                <strong>
                                  {" "}
                                  {roleData.roleplay_sentiment_positive}%
                                </strong>
                              </div>
                              <div className="rolerate">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="27.431"
                                  height="27.431"
                                  viewBox="0 0 27.431 27.431"
                                >
                                  <g
                                    id="sad_1_"
                                    data-name="sad (1)"
                                    transform="translate(0.5 0.5)"
                                  >
                                    <g
                                      id="Ellipse_59"
                                      data-name="Ellipse 59"
                                      transform="translate(6.176 7.124)"
                                      fill="#e78312"
                                      stroke="#e78312"
                                      strokeWidth="0.5"
                                    >
                                      <ellipse
                                        cx="2.348"
                                        cy="2.348"
                                        rx="2.348"
                                        ry="2.348"
                                        stroke="none"
                                      />
                                      <ellipse
                                        cx="2.348"
                                        cy="2.348"
                                        rx="2.598"
                                        ry="2.598"
                                        fill="none"
                                      />
                                    </g>
                                    <g
                                      id="Ellipse_60"
                                      data-name="Ellipse 60"
                                      transform="translate(15.558 7.124)"
                                      fill="#e78312"
                                      stroke="#e78312"
                                      strokeWidth="0.5"
                                    >
                                      <ellipse
                                        cx="2.348"
                                        cy="2.348"
                                        rx="2.348"
                                        ry="2.348"
                                        stroke="none"
                                      />
                                      <ellipse
                                        cx="2.348"
                                        cy="2.348"
                                        rx="2.598"
                                        ry="2.598"
                                        fill="none"
                                      />
                                    </g>
                                    <g
                                      id="Rectangle_321"
                                      data-name="Rectangle 321"
                                      transform="translate(8.156 17.099)"
                                      fill="#e78312"
                                      stroke="#e78312"
                                      strokeWidth="0.5"
                                    >
                                      <rect
                                        width="10.118"
                                        height="1.686"
                                        stroke="none"
                                      />
                                      <rect
                                        x="-0.25"
                                        y="-0.25"
                                        width="10.618"
                                        height="2.186"
                                        fill="none"
                                      />
                                    </g>
                                    <g
                                      id="Path_12029"
                                      data-name="Path 12029"
                                      transform="translate(0 0)"
                                      fill="#e78312"
                                    >
                                      <path
                                        d="M 22.70437622070312 26.68081855773926 L 3.726535558700562 26.68081855773926 C 1.533865451812744 26.68081855773926 -0.2499945014715195 24.8969783782959 -0.2499945014715195 22.7043399810791 L -0.2499945014715195 3.726529359817505 C -0.2499945014715195 1.533859252929688 1.533865451812744 -0.2500007152557373 3.726535558700562 -0.2500007152557373 L 22.70431518554688 -0.2500007152557373 C 24.89698600769043 -0.2500007152557373 26.68085479736328 1.533859252929688 26.68085479736328 3.726529359817505 L 26.68085479736328 22.70428848266602 C 26.68085479736328 24.89695930480957 24.89701461791992 26.68081855773926 22.70437622070312 26.68081855773926 Z M 3.726535558700562 1.901929259300232 C 2.720445394515991 1.901929259300232 1.901925444602966 2.720439195632935 1.901925444602966 3.726529359817505 L 1.901925444602966 22.7043399810791 C 1.901925444602966 23.71043014526367 2.720445394515991 24.52894020080566 3.726535558700562 24.52894020080566 L 22.70437622070312 24.52894020080566 C 23.7104663848877 24.52894020080566 24.52897644042969 23.71043014526367 24.52897644042969 22.7043399810791 L 24.52897644042969 3.726529359817505 C 24.52897644042969 2.720439195632935 23.7104663848877 1.901929259300232 22.70437622070312 1.901929259300232 L 3.726535558700562 1.901929259300232 Z"
                                        stroke="none"
                                      />
                                      <path
                                        d="M 22.70437622070312 26.43081855773926 C 24.75874519348145 26.43081855773926 26.43085479736328 24.75871849060059 26.43085479736328 22.70428848266602 L 26.43085479736328 3.726529359817505 C 26.43085479736328 1.671669244766235 24.75874519348145 -7.211303909571143e-07 22.70431518554688 -7.211303909571143e-07 L 3.726535558700562 -7.211303909571143e-07 C 1.671675443649292 -7.211303909571143e-07 5.491333013196709e-06 1.671669244766235 5.491333013196709e-06 3.726529359817505 L 5.491333013196709e-06 22.7043399810791 C 5.491333013196709e-06 24.75871849060059 1.671675443649292 26.43081855773926 3.726535558700562 26.43081855773926 L 22.70437622070312 26.43081855773926 M 3.726535558700562 1.651929259300232 L 22.70437622070312 1.651929259300232 C 23.84812545776367 1.651929259300232 24.77897644042969 2.582779169082642 24.77897644042969 3.726529359817505 L 24.77897644042969 22.7043399810791 C 24.77897644042969 23.84809875488281 23.84812545776367 24.77894020080566 22.70437622070312 24.77894020080566 L 3.726535558700562 24.77894020080566 C 2.582785606384277 24.77894020080566 1.651925444602966 23.84809875488281 1.651925444602966 22.7043399810791 L 1.651925444602966 3.726529359817505 C 1.651925444602966 2.582779169082642 2.582785606384277 1.651929259300232 3.726535558700562 1.651929259300232 M 22.70437622070312 26.93081855773926 L 3.726535558700562 26.93081855773926 C 1.396015524864197 26.93081855773926 -0.4999945163726807 25.03483009338379 -0.4999945163726807 22.7043399810791 L -0.4999945163726807 3.726529359817505 C -0.4999945163726807 1.39600932598114 1.396015524864197 -0.5000007152557373 3.726535558700562 -0.5000007152557373 L 22.70431518554688 -0.5000007152557373 C 25.03483581542969 -0.5000007152557373 26.93085479736328 1.39600932598114 26.93085479736328 3.726529359817505 L 26.93085479736328 22.70428848266602 C 26.93085479736328 25.03480911254883 25.03486633300781 26.93081855773926 22.70437622070312 26.93081855773926 Z M 3.726535558700562 2.151929378509521 C 2.858295440673828 2.151929378509521 2.151925563812256 2.858289241790771 2.151925563812256 3.726529359817505 L 2.151925563812256 22.7043399810791 C 2.151925563812256 23.57257843017578 2.858295440673828 24.27894020080566 3.726535558700562 24.27894020080566 L 22.70437622070312 24.27894020080566 C 23.5726146697998 24.27894020080566 24.27897644042969 23.57257843017578 24.27897644042969 22.7043399810791 L 24.27897644042969 3.726529359817505 C 24.27897644042969 2.858289241790771 23.5726146697998 2.151929378509521 22.70437622070312 2.151929378509521 L 3.726535558700562 2.151929378509521 Z"
                                        stroke="none"
                                        fill="#e78312"
                                      />
                                    </g>
                                  </g>
                                </svg>
                                <strong>
                                  {" "}
                                  {roleData.roleplay_sentiment_neutral}%
                                </strong>
                              </div>
                              <div className="rolerate">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="27.431"
                                  height="27.431"
                                  viewBox="0 0 27.431 27.431"
                                >
                                  <g id="sad" transform="translate(0.5 0.5)">
                                    <g
                                      id="Ellipse_61"
                                      data-name="Ellipse 61"
                                      transform="translate(6.176 7.124)"
                                      fill="#e91e63"
                                      stroke="#e91e63"
                                      strokeWidth="0.5"
                                    >
                                      <ellipse
                                        cx="2.348"
                                        cy="2.348"
                                        rx="2.348"
                                        ry="2.348"
                                        stroke="none"
                                      />
                                      <ellipse
                                        cx="2.348"
                                        cy="2.348"
                                        rx="2.598"
                                        ry="2.598"
                                        fill="none"
                                      />
                                    </g>
                                    <g
                                      id="Ellipse_62"
                                      data-name="Ellipse 62"
                                      transform="translate(15.558 7.124)"
                                      fill="#e91e63"
                                      stroke="#e91e63"
                                      strokeWidth="0.5"
                                    >
                                      <ellipse
                                        cx="2.348"
                                        cy="2.348"
                                        rx="2.348"
                                        ry="2.348"
                                        stroke="none"
                                      />
                                      <ellipse
                                        cx="2.348"
                                        cy="2.348"
                                        rx="2.598"
                                        ry="2.598"
                                        fill="none"
                                      />
                                    </g>
                                    <g
                                      id="Path_12030"
                                      data-name="Path 12030"
                                      transform="translate(-112.815 -282.114)"
                                      fill="#e91e63"
                                    >
                                      <path
                                        d="M 131.7559204101562 302.1356811523438 L 131.5505828857422 301.9761657714844 C 129.9112396240234 300.7027587890625 128.119384765625 300.0570983886719 126.2247619628906 300.0570983886719 C 123.0341262817383 300.0570983886719 120.6126861572266 301.8982543945312 120.5111694335938 301.9766235351562 L 120.3062133789062 302.1348876953125 L 120.1552581787109 301.9244689941406 L 119.1858978271484 300.5733337402344 L 119.0449600219727 300.3768920898438 L 119.2365875244141 300.2294616699219 C 119.3605422973633 300.1341247558594 122.3177719116211 297.8942260742188 126.2904510498047 297.8942260742188 C 128.6321105957031 297.8942260742188 130.8306579589844 298.6798400878906 132.8250427246094 300.2292785644531 L 133.0148468017578 300.3767395019531 L 132.8749542236328 300.5722045898438 L 131.9072418212891 301.9242553710938 L 131.7559204101562 302.1356811523438 Z"
                                        stroke="none"
                                      />
                                      <path
                                        d="M 131.7039489746094 301.7787475585938 L 132.6716613769531 300.4266967773438 C 126.0935974121094 295.3161315917969 119.4554443359375 300.3765258789062 119.389030456543 300.4276123046875 L 120.3583908081055 301.7787475585938 C 120.5908203125 301.5992736816406 126.1102066040039 297.43359375 131.7039489746094 301.7787475585938 M 131.8078918457031 302.4926147460938 L 131.3972320556641 302.1736145019531 C 129.8027648925781 300.9350891113281 128.0625152587891 300.3070983886719 126.2247619628906 300.3070983886719 C 123.1184616088867 300.3070983886719 120.7627105712891 302.0982666015625 120.6639404296875 302.1745300292969 L 120.254020690918 302.4909973144531 L 118.7008819580078 300.326171875 L 119.0841598510742 300.0313110351562 C 119.2108612060547 299.933837890625 122.2337493896484 297.6442260742188 126.2904510498047 297.6442260742188 C 128.68896484375 297.6442260742188 130.9391326904297 298.4475402832031 132.9784088134766 300.0318603515625 L 133.3580322265625 300.3267822265625 L 131.8078918457031 302.4926147460938 Z"
                                        stroke="none"
                                        fill="#e91e63"
                                      />
                                    </g>
                                    <g
                                      id="Path_12031"
                                      data-name="Path 12031"
                                      transform="translate(0 0)"
                                      fill="#e91e63"
                                    >
                                      <path
                                        d="M 22.70437622070312 26.68081855773926 L 3.726536512374878 26.68081855773926 C 1.533866405487061 26.68081855773926 -0.2500035464763641 24.8969783782959 -0.2500035464763641 22.7043399810791 L -0.2500035464763641 3.726529359817505 C -0.2500035464763641 1.533859252929688 1.533866405487061 -0.2500007152557373 3.726536512374878 -0.2500007152557373 L 22.70431709289551 -0.2500007152557373 C 24.89698600769043 -0.2500007152557373 26.68085670471191 1.533859252929688 26.68085670471191 3.726529359817505 L 26.68085670471191 22.70428848266602 C 26.68085670471191 24.89695930480957 24.89701652526855 26.68081855773926 22.70437622070312 26.68081855773926 Z M 3.726536512374878 1.901929259300232 C 2.720446348190308 1.901929259300232 1.901926398277283 2.720439195632935 1.901926398277283 3.726529359817505 L 1.901926398277283 22.7043399810791 C 1.901926398277283 23.71043014526367 2.720446348190308 24.52894973754883 3.726536512374878 24.52894973754883 L 22.70437622070312 24.52894973754883 C 23.7104663848877 24.52894973754883 24.52897644042969 23.71043014526367 24.52897644042969 22.7043399810791 L 24.52897644042969 3.726529359817505 C 24.52897644042969 2.720439195632935 23.7104663848877 1.901929259300232 22.70437622070312 1.901929259300232 L 3.726536512374878 1.901929259300232 Z"
                                        stroke="none"
                                      />
                                      <path
                                        d="M 22.70437622070312 26.43081855773926 C 24.75874710083008 26.43081855773926 26.43085670471191 24.75871849060059 26.43085670471191 22.70428848266602 L 26.43085670471191 3.726529359817505 C 26.43085670471191 1.671669244766235 24.75874710083008 -7.211303909571143e-07 22.70431709289551 -7.211303909571143e-07 L 3.726536512374878 -7.211303909571143e-07 C 1.672106504440308 -7.211303909571143e-07 -3.554992645149468e-06 1.671669244766235 -3.554992645149468e-06 3.726529359817505 L -3.554992645149468e-06 22.7043399810791 C -3.554992645149468e-06 24.75871849060059 1.672106504440308 26.43081855773926 3.726536512374878 26.43081855773926 L 22.70437622070312 26.43081855773926 M 3.726536512374878 1.651929259300232 L 22.70437622070312 1.651929259300232 C 23.8481273651123 1.651929259300232 24.77897644042969 2.582779169082642 24.77897644042969 3.726529359817505 L 24.77897644042969 22.7043399810791 C 24.77897644042969 23.84809875488281 23.8481273651123 24.77894973754883 22.70437622070312 24.77894973754883 L 3.726536512374878 24.77894973754883 C 2.582776546478271 24.77894973754883 1.651926398277283 23.84809875488281 1.651926398277283 22.7043399810791 L 1.651926398277283 3.726529359817505 C 1.651926398277283 2.582779169082642 2.58272647857666 1.651929259300232 3.726536512374878 1.651929259300232 M 22.70437622070312 26.93081855773926 L 3.726536512374878 26.93081855773926 C 1.396016478538513 26.93081855773926 -0.5000035762786865 25.03483009338379 -0.5000035762786865 22.7043399810791 L -0.5000035762786865 3.726529359817505 C -0.5000035762786865 1.39600932598114 1.396016478538513 -0.5000007152557373 3.726536512374878 -0.5000007152557373 L 22.70431709289551 -0.5000007152557373 C 25.03483581542969 -0.5000007152557373 26.93085670471191 1.39600932598114 26.93085670471191 3.726529359817505 L 26.93085670471191 22.70428848266602 C 26.93085670471191 25.03480911254883 25.03486633300781 26.93081855773926 22.70437622070312 26.93081855773926 Z M 3.726536512374878 2.151929378509521 C 2.858296394348145 2.151929378509521 2.151926517486572 2.858289241790771 2.151926517486572 3.726529359817505 L 2.151926517486572 22.7043399810791 C 2.151926517486572 23.57257843017578 2.858296394348145 24.27894973754883 3.726536512374878 24.27894973754883 L 22.70437622070312 24.27894973754883 C 23.57261657714844 24.27894973754883 24.27897644042969 23.57257843017578 24.27897644042969 22.7043399810791 L 24.27897644042969 3.726529359817505 C 24.27897644042969 2.858289241790771 23.57261657714844 2.151929378509521 22.70437622070312 2.151929378509521 L 3.726536512374878 2.151929378509521 Z"
                                        stroke="none"
                                        fill="#e91e63"
                                      />
                                    </g>
                                  </g>
                                </svg>
                                <strong>
                                  {" "}
                                  {roleData.roleplay_sentiment_negative}%
                                </strong>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
                  <div className="col-lg-5 col-sm-12 myrole-feedback">
                    <div className="review-overview-card">
                        <div className="overview-row d-flex">
                        <div className="overview-title">Title</div>
                        <div className="video-title-info">{roleInfo.title}</div>
                    </div>
                    <div className="overview-row d-flex flex-column scnario-title">
                        <div className="overview-title">Scenario</div>
                        <div className="video-title-info scenario-block">{roleInfo.situation}</div>
                    </div>
                    <div className="overview-row d-flex">
                        <div className="overview-title">Duration</div>
                        <div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24.897 24.897"
                          >
                            <path
                              id="clock-time-four"
                              d="M14.449,2A12.449,12.449,0,1,0,26.9,14.449,12.485,12.485,0,0,0,14.449,2M19.8,18.432l-6.6-3.61v-6.6h1.867V13.7l5.6,3.112Z"
                              transform="translate(-2 -2)"
                              fill="#415385"
                            />
                          </svg>
                          <span>
                            <strong> {roleInfo.roleplay_duration}</strong>{" "}
                            mins
                          </span>
                        </div>
                    </div>
                    <div className="overview-row asgapbtm d-flex align-items-center">
                        <div className="overview-title">End user</div>
                        <div className="usernamewimg userbox">  <img className="userimgrolefg" src="https://realtorsuccessfrontity-dev.niit-mts.com/wp-content/uploads/2022/12/shradesh-9@mailinator.com-20221229040622.png" /> {roleInfo.userFirstName}&nbsp;{roleInfo.userLastName}</div>
                    </div>  
                    {rolePlayGuide ?
                      <div>
                        Learn <a href={rolePlayGuide} target="_blank">How to Give Scores</a> to the participants.
                      </div>
                    : ""}         
                    {
                      reviewType === 'pending' ?
                      <Formik
                      initialValues={initialValues}
                      validationSchema={formSchema}
                      onSubmit={handleSubmit}
                      enableReinitialize
                    >
                      {(formik) => {
                        const { handleSubmit } = formik;
                        formikInstance = formik;
                        return (
                          <form onSubmit={handleSubmit} autoComplete="off">
                            <div className="feedback-rating-card mt-2">
                              {
                                rubricData.map((data, index) => {
                                  return (
                                    <div className="feedback-rating-row d-flexs justify-content-between">
                                      <div className="feedback-rating-title">
                                        {data}
                                      </div>
                                      <Rating
                                        name={data}
                                        precision={0.5}
                                        max={3}
                                        // getLabelText={getLabelText}
                                        onChange={(event, newValue) => {
                                          // setValue(newValue);
                                          // console.log(newValue)
                                          console.log(`rating[${data}]`)
                                          formik.setFieldValue(
                                            `rating[${data}]`,
                                            newValue
                                          );
                                        }}
                                        onChangeActive={(event, newHover) => {
                                          // setHover(newHover);
                                          // console.log(newHover)
                                        }}
                                        emptyIcon={
                                          <StarIcon
                                            style={{ opacity: 0.55 }}
                                            fontSize="inherit"
                                          />
                                        }
                                      />
                                    </div>
                                  )
                                })
                              }
                            </div>
                            <div className="form-role-play reviewform fbrolmt showcomenuser">
                                <div className="overview-card-frm-section">
                                  <div className="overview-row coacfeedback">
                                      <h5 className="headfrf">Additional comments for participant</h5>
                                      <div className="input-text position-relative d-flex">
                                            {/* <label for="date_join" className="input__label">
                                              Addtional Comments*
                                            </label> */}
                                            <textarea
                                              className="input__field commentfield mb-0"
                                              name="comments"
                                              id="comments"
                                              onChange={formik.handleChange}
                                              onBlur={formik.handleBlur}
                                              rows="4"
                                              cols="50"
                                              placeholder=""
                                            ></textarea>
                                          </div>
                                          <span className="error-message">
                                            {formik.errors.comments
                                              ? formik.errors.comments
                                              : ""}
                                          </span>
                                  </div>
                              </div>
                            </div>
                          </form>
                        );
                      }}
                      </Formik>
                      :
                      <>
                        {!_.isEmpty(roleInfo.feedbackData.rating) ?
                          <div className="feedback-rating-card mt-2">
                              {
                                  !_.isEmpty(roleInfo.feedbackData.rating) ?
                                      Object.keys(roleInfo.feedbackData.rating).map((data, index) => {
                                          return (
                                              <div className="feedback-rating-row d-flex justify-content-between">
                                                  <div className="feedback-rating-title">{data}</div>
                                                  {/* <div className="quotsformoti">{starRatingCaptions(_.toNumber(roleInfo.feedbackData.rating[data]))}</div> */}
                                                  <Rating
                                                      name="awarness"
                                                      precision={0.5}
                                                      max={3}
                                                      readOnly
                                                      value={_.toNumber(roleInfo.feedbackData.rating[data])}
                                                      // getLabelText={getLabelText}
                                                      onChange={(event, newValue) => {
                                                          // setValue(newValue);
                                                          // console.log(newValue)
                                                      }}
                                                      onChangeActive={(event, newHover) => {
                                                          // setHover(newHover);
                                                          // console.log(newHover)
                                                      }}
                                                      emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
                                                  />
                                              </div>
                                          )
                                      })
                                      : ""
                              }
                          </div>
                          : ""
                        }
                        <div className="overview-card-section comment-reivew">
                          <div className="overview-row">
                            <h5 className="headfrf">Your Comment</h5>
                            <div className="d-flex ratings-role">
                              {roleInfo.feedbackData.additional_comment ? roleInfo.feedbackData.additional_comment : '-'}
                            </div>
                          </div>
                        </div>
                      </>
                    }
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-sm-12">         
                  <div className="form-role-play reviewform fbrolmt">
                    <div className="row">
                      <div className="col-lg-7 col-sm-12">
                        {/* {rolePlayGuide ? 
                          <div className="instrubox">
                            Please follow instruction mention in guide for ratings.
                            <div className="pdf-download-role">
                            {" "}
                              <a href={rolePlayGuide} target="_blank">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                >
                                    <defs>
                                    <linearGradient
                                        id="linear-gradient"
                                        x2="1"
                                        y1="0.5"
                                        y2="0.5"
                                        gradientUnits="objectBoundingBox"
                                    >
                                        <stop offset="0" stopColor="#415385"></stop>
                                        <stop offset="1" stopColor="#415385"></stop>
                                    </linearGradient>
                                    </defs>
                                    <circle
                                    cx="15"
                                    cy="15"
                                    r="15"
                                    fill="url(#linear-gradient)"
                                    data-name="Ellipse 180"
                                    ></circle>
                                    <circle
                                    cx="13"
                                    cy="13"
                                    r="13"
                                    fill="#fff"
                                    data-name="Ellipse 181"
                                    transform="translate(2 2)"
                                    ></circle>
                                    <path
                                    fill="#415385"
                                    d="M5.684 8a3.015 3.015 0 01-.062-1.466c.262.003.237 1.157.062 1.466zm-.053 1.478a14.42 14.42 0 01-.887 1.959 11.507 11.507 0 011.966-.684 4.048 4.048 0 01-1.079-1.275zm-2.941 3.9c0 .025.412-.169 1.091-1.256a4.319 4.319 0 00-1.09 1.256zM7.75 5H12v10.25a.748.748 0 01-.75.75H.75a.748.748 0 01-.75-.75V.75A.748.748 0 01.75 0H7v4.25a.752.752 0 00.75.75zm-.25 5.369a3.136 3.136 0 01-1.334-1.681 4.492 4.492 0 00.194-2.006.783.783 0 00-1.494-.213 5.2 5.2 0 00.253 2.406 29.344 29.344 0 01-1.275 2.681h-.006c-.847.434-2.3 1.391-1.7 2.125a.971.971 0 00.668.319c.559 0 1.116-.562 1.909-1.931a17.813 17.813 0 012.469-.725 4.736 4.736 0 002 .609.809.809 0 00.616-1.359c-.434-.425-1.7-.3-2.3-.225zm4.281-7.087L8.719.219A.749.749 0 008.188 0H8v4h4v-.191a.748.748 0 00-.219-.528zm-2.315 7.977c.128-.084-.078-.372-1.338-.281 1.16.494 1.338.281 1.338.281z"
                                    data-name="Icon awesome-file-pdf"
                                    transform="translate(9 7)"
                                    ></path>
                                </svg>
                              </a>
                            </div>
                          </div>
                        : ''} */}
                          <div className="row">
                            {/* <div className="col-lg-12 col-sm-12 scoresecfbbtm mt-2">
                              <span className="scoredigit">{_.toNumber(overallScore)}</span> <label className="scoretitledf">OVERALL SCORE</label>
                            </div>
                            <div className="col-lg-5 col-sm-12">
                                <h5 className="headfrf">Keyword Analysis</h5>
                                <div className="feedback-rating-card mt-2 accordion-box">
                                    {
                                        !_.isEmpty(roleInfo.roleplay_keyword_analysis) ?
                                            roleInfo.roleplay_keyword_analysis.map((keyword, index) => {
                                                return (
                                                    <div
                                                        className="accordion-item-div"
                                                        key={`keyword-${index + 1}`}>
                                                        {keyword.kw}<span className="ratingbox">{keyword.wt}</span>
                                                    </div>
                                                )
                                            })
                                            :
                                            ""
                                    }
                                </div>
                            </div> */}
                            <div className="col-lg-12 col-sm-12">
                                <div className="overview-card-section">
                                  <div className="overview-row">
                                    <h5 className="headfrf">Additional comments from participant</h5>
                                    <div className="d-flex ratings-role">
                                      {roleData.additionalComment ? roleData.additionalComment : '-'}
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </div>
                      </div>
                      
                    </div>
                    {
                      reviewType === 'pending' ?
                      <>
                        <div className="role_frm_upload_btn edit_btn d-flex mt-4">
                          <button className="btn-primary"
                            onClick={() => {
                              if (!isSubmit) {
                                formikInstance.handleSubmit()
                              }
                            }}
                          >
                            {isSubmit ? (
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                variant="primary"
                              />
                            ) : (
                              "Send Feedback"
                            )}
                          </button>
                        </div>
                        <div className="form-msg">
                          <span>{msg}</span>
                        </div>
                      </>
                      : ""
                    }
                  </div>
                </div>
              </div>
            </div>
          ) : listing.length ? (
            ""
          ) : (
            ""
          )}
        </div>
      </section>
    </>
  );
};

export default ReviewOverView;
